import Request from '@/helpers/request';


const prepareHash = (hash, uriEncoded = true) => {
  let output = [];
  for (let i = 0; i < hash.length; i += 2) {
    if (i == 0) {
      output[0] = hash[0] + hash[1];
    } else {
      output[i / 2] = hash[i] + hash[i + 1];
    }
  }

  if (uriEncoded) {
    return encodeURIComponent(output.join(':'));
  }

  return output.join(':');
}

export default class PublicPackageApi {
  static async getChart(params) {
    const { samples, start_date, end_date, hash } = params;
    return Request.client.get(`/public/package/${prepareHash(hash)}/charts`, {
      params: {
        samples, start_date, end_date
      }
    });
  }

  static async getShipment(params) {
    const { hash } = params;
    return Request.client.get(`/public/package/${prepareHash(hash)}/destination`);
  }

  static async getTrack(params) {
    const { distance, hash } = params;
    return Request.client.get(`/public/package/${prepareHash(hash)}/track`, {
      params: { distance }
    });
  }

  static async exportPdf(sensorUid) {
    return Request.client.put('/package/exportPdfPublic', { deviceHash: prepareHash(sensorUid, false) });
  }

  static async getTransactions(params) {
    const { hash } = params;
    return Request.client.get(`/public/package/${prepareHash(hash)}/transactions`, {
      params: PublicPackageApi.prepareParams(params)
    });
  }

  static prepareParams(params) {
    return {
      __order: (params.orderBy) ? `${params.orderBy.value} ${params.orderBy.desc ? 'desc' : 'asc'}` : null,
      __count: (params.limit) ? `${params.limit.count}` : null,
      __offset: (params.limit) ? `${params.limit.offset}` : null,
      term: params.term,
      distance: params.distance,
    };
  }
}